import React from 'react'
import './Footer.css'

const Footer = () => {
	return (
		<div style={{ backgroundColor: '#9c1302' }}>
			<footer>
				<div>
					<div className='row'>
						<div className='col text-center'>
							<h1
								className='font-weight-light text-capitalize p-3'
								style={{ color: '#fbe212', textShadow: 'black 2px 2px 2px' }}
							>
								Greater Pitt Dek Hockey
							</h1>
							<div className='py-3'>
								<a
									href='https://www.facebook.com/greaterpittsburghdekhockey'
									target='_blank'
									style={{ color: '#fbe212' }}
								>
									<i
										className='fa fa-facebook-square fa-4x mx-3'
										style={{ textShadow: 'black 2px 2px 2px' }}
									></i>
								</a>
							</div>
							<p
								className='py-4 m-0 copyright'
								style={{ color: 'white', backgroundColor: '#686868' }}
							>
								A Web Application by{' '}
								<a
									href='https://www.shireystatsandstandings.com/#'
									target='_blank'
									style={{ color: 'white' }}
								>
									Shirey Stats and Standings, LLC
								</a>
							</p>
						</div>
					</div>
				</div>
			</footer>
		</div>
	)
}

export default Footer
